import React, { useState } from "react";
import "../Aboutus/Projects.css";

const projectsData = [
  { id: 1, name: "Copper", image: "copper.webp" },
  { id: 2, name: "Refined Metal Sales", image: "refind.webp" },
  { id: 3, name: "Steelmaking Coal", image: "steel.webp" },
  { id: 4, name: "Zinc", image: "zinc.webp" },
  { id: 5, name: "Energy", image: "energy.webp" },
  { id: 6, name: "Industrial Products", image: "product.webp" },
];

const Projects = () => {
  return (
    <div className="projects-section">
      {projectsData.map((project) => (
        <div className="project-item" key={project.id}>
          <span className="project-number">{`0${project.id}`}</span>
          <h1 className="project-name">{project.name}</h1>
          <div className="hover-image-container">
            <img src={project.image} alt={project.name} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Projects;
